import { LandingPage } from "./views/landing-page";

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;
